module.exports = __webpack_public_path__ + "media/images/padlet_logo_black-a8ce9e2c8ece9eb1525f612972a12b48.svg";